import Vue from 'vue'
import App from './App.vue'
import '@/assets/scss/common.scss'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')

import Toasted from "vue-toasted";
Vue.use(Toasted, {
  theme: "bubble",
  position: "top-center",
  duration: 2000,
  fullWidth: false,
});